.root {
  display: flex;
  gap: 1rem;
  background: var(--background);

  @media (--md-down) {
    flex-direction: column;
  }
}

.preset {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 260px;
  height: 40px;
  padding: 0 1rem;
  font-weight: var(--font-weight-light);
  text-align: left;
  appearance: none;
  cursor: pointer;
  background: none;
  border: none;

  &:hover {
    background-color: var(--dropdown-item-background-hover);
  }
}

.active {
  background-color: var(--dropdown-item-background-hover);
}

.presetOpen {
  border-right: 1px solid var(--gray-200);
}
